import { useRef } from "react";
import { useNavigate } from "@remix-run/react";
import { cx } from "class-variance-authority";
import { CSSTransition } from "react-transition-group";
import IcNavigationBack from "~/images/ic_navigation_back.svg";
import { typography } from "~/styles/typographies";
import { gtag } from "~/utils/gtag";
import styles from "./ContentInfo.module.css";

interface ContentInfoProps {
  title: string;
  description: string;
  visible: boolean;
  seasonId: string;
  episodeNumber: number;
}

export function ContentInfo({
  title,
  description,
  visible,
  seasonId,
  episodeNumber,
}: ContentInfoProps) {
  const nodeRef = useRef(null);
  const navigate = useNavigate();

  function handleClickBack() {
    gtag.sendEvent({
      eventName: "w_close",
      wEventId: 7,
      screenName: "player",
      wEpisodeNumber: episodeNumber,
      wSeasonCode: seasonId,
      wIsFree: true,
    });
    if (window.history.length === 1) {
      navigate("/");
    } else {
      navigate(-1);
    }
  }

  return (
    <CSSTransition
      classNames="content-info"
      in={visible}
      nodeRef={nodeRef}
      timeout={300}
    >
      <div
        ref={nodeRef}
        className={cx(styles.contentInfo, visible && styles.visible)}
      >
        <button
          className={styles.backButton}
          type="button"
          onClick={handleClickBack}
        >
          <img alt="back" src={IcNavigationBack} />
        </button>
        <div className={styles.right}>
          <h1
            className={cx(
              styles.title,
              typography({ fontSize: "body1", fontWeight: "medium" }),
            )}
          >
            {title}
          </h1>
          <p
            className={cx(
              styles.description,
              typography({ fontSize: "body4", fontWeight: "medium" }),
            )}
          >
            {description}
          </p>
        </div>
      </div>
    </CSSTransition>
  );
}
